import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { reaction } from "mobx";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Credits } from "./Credits";
import { CreditsContainer } from "./CreditsContainer";
import { DataAttributionModal } from "./DataAttribution/DataAttributionModal";
import { MapCreditLogo } from "./MapCreditLogo";
import { Spacer } from "./Spacer";
import { TerriaLogo } from "./TerriaLogo";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MapCredits = observer(_ref => {
  let {
    currentViewer,
    hideTerriaLogo,
    credits,
    searchBarModel
  } = _ref;
  const {
    t
  } = useTranslation();
  const [dataAttributionVisible, setDataAttributionVisible] = useState(false);
  const searchAttributions = searchBarModel.locationSearchProvidersArray.map(provider => {
    var _provider$attribution;
    return (_provider$attribution = provider.attributions) === null || _provider$attribution === void 0 ? void 0 : _provider$attribution.flat();
  }).flat().filter(attribution => !!attribution);
  const showDataAttribution = useCallback(() => {
    setDataAttributionVisible(true);
  }, [setDataAttributionVisible]);
  const hideDataAttribution = useCallback(() => {
    setDataAttributionVisible(false);
  }, [setDataAttributionVisible]);
  useEffect(() => {
    return reaction(() => currentViewer.attributions.length, () => {
      if (currentViewer.attributions && currentViewer.attributions.length === 0) {
        hideDataAttribution();
      }
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [currentViewer]);
  if (currentViewer.type === "none") {
    return /*#__PURE__*/_jsx(CreditsContainer, {});
  }
  return /*#__PURE__*/_jsxs(CreditsContainer, {
    children: [!hideTerriaLogo ? /*#__PURE__*/_jsx(TerriaLogo, {}) : null, /*#__PURE__*/_jsx(MapCreditLogo, {
      currentViewer: currentViewer
    }), /*#__PURE__*/_jsx(Credits, {
      credits: credits
    }), /*#__PURE__*/_jsx(Spacer, {}), currentViewer.attributions && currentViewer.attributions.length > 0 || currentViewer.attributions.length > 0 ? /*#__PURE__*/_jsx("a", {
      onClick: showDataAttribution,
      children: t("map.extraCreditLinks.credits")
    }) : null, dataAttributionVisible ? /*#__PURE__*/_jsx(DataAttributionModal, {
      closeModal: hideDataAttribution,
      attributions: currentViewer.attributions,
      searchAttributions: searchAttributions
    }) : null]
  });
});